"use client";

import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import React from "react";
import { Controller, FieldValues, Path, UseFormReturn } from "react-hook-form";
import { ColorPickerInput, ColorPickerInputProps } from "./ColorPickerInput";

export interface HookFormColorPickerInputProps<T extends FieldValues>
  extends Omit<ColorPickerInputProps, "value" | "onChange" | "error"> {
  form: UseFormReturn<T>;
  name: Path<T>;
  isRequired?: boolean;
  rules?: Parameters<typeof buildControllerRules>[0]["rules"];
}

export const HookFormColorPickerInput = <T extends FieldValues>({
  form,
  name,
  rules,
  isRequired,
  ...props
}: HookFormColorPickerInputProps<T>): React.ReactElement => {
  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired
      })}
      render={({ field, fieldState }) => (
        <ColorPickerInput
          {...props}
          value={field.value}
          onChange={field.onChange}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
